export default {
  appCors: process.env.VUE_APP_CORS_ORIGIN || 'http://localhost:8080',
  apiUrl: process.env.VUE_APP_API_URL || 'http://localhost:3000/api',
  wsUrl: process.env.VUE_APP_WS_URL || 'ws://localhost:3000/api'
}
